import { gql } from "@apollo/client";

export const GET_SETTING = gql`
    query Setting($culture: String!) {
        setting(where: {localization: {culture: $culture}}) {
            underMaintenanceUntil
            underMaintenanceMessage {
                html    
            }
            bookingDisableUntil
            bookingDisableMessage {
                html
            }
            modificationDisableMessage {
                html
            }
            checkinDisableUntil
            checkinDisableMessage {
                html
            }
            paymentGateways {
                contentItems {
                    __typename
                    ... on PaymentGateway {
                        gatewayId
                        displayText
                        enabled
                        logo {
                            paths
                        }
                    }
                }
            }
        }
    }
`